import {
  AddPreviewFilter,
  Module,
  PreviewContentUpdate,
  UpdatePreviewFilter,
} from '../../interfaces/module.interface';
import { ModulesActions, ModulesActionsUnion } from '../actions/module.action';
import { ModuleState, initialModuleState } from '../state/module.state';

export const moduleReducer = (
  state = initialModuleState,
  action: ModulesActionsUnion,
): ModuleState => {
  switch (action.type) {
    case ModulesActions.LoadModules: {
      return ModuleReducers.addModules(state, action.payload);
    }

    case ModulesActions.UpdatePreviewContent: {
      return ModuleReducers.updatePreviewContent(state, action.payload);
    }

    case ModulesActions.AddPreviewFilters: {
      return ModuleReducers.addPreviewFilters(state, action.payload);
    }

    case ModulesActions.UpdatePreviewFilters: {
      return ModuleReducers.updatePreviewFilter(state, action.payload);
    }
    case ModulesActions.UpdateLastVisitedStatus: {
      return ModuleReducers.UpdateLastVisitedStatus(state, action.payload);
    }

    default:
      return state;
  }
};

export class ModuleReducers {
  static addModules(state: ModuleState, payload: Module[]): ModuleState {
    return {
      ...state,
      modules: payload,
    };
  }

  static addPreviewFilters(
    state: ModuleState,
    payload: AddPreviewFilter,
  ): ModuleState {
    const updatedModules = state.modules.map((module, moduleIndex) => {
      if (moduleIndex === payload.moduleIndex) {
        return {
          ...module,
          previewFilters: payload.previewFilters,
        };
      }
      return module;
    });

    return {
      ...state,
      modules: updatedModules,
    };
  }

  static updatePreviewFilter(
    state: ModuleState,
    payload: UpdatePreviewFilter,
  ): ModuleState {
    const updatedModule = state.modules.map((module, moduleIndex) => {
      return moduleIndex === payload.moduleIndex
        ? { ...module, previewFilters: payload.previewFilter }
        : module;
    });

    return {
      ...state,
      modules: updatedModule,
    };
  }

  static updatePreviewContent(
    state: ModuleState,
    payload: PreviewContentUpdate,
  ): ModuleState {
    const updatedModules = state.modules.map((module, moduleIndex) => {
      if (moduleIndex === payload.moduleIndex) {
        const updatedPreviewContent = module.activities.map(
          (activity, activityIndex) => {
            if (activityIndex === payload.activityIndex) {
              return {
                ...activity,
                previewContent: payload.previewContent,
              };
            }
            return activity;
          },
        );

        return { ...module, activities: updatedPreviewContent };
      }
      return module;
    });

    return {
      ...state,
      modules: updatedModules,
    };
  }

  static UpdateLastVisitedStatus(
    state: ModuleState,
    payload: number,
  ): ModuleState {
    const updatedModule = state.modules.map((module, moduleIndex) => {
      if (moduleIndex === payload) {
        return { ...module, isLastVisited: true };
      } else {
        const clearActivityCheckBoxSelection = module.activities.map(
          (activity) => {
            return {
              ...activity,
              isSelected: false,
            };
          },
        );

        return {
          ...module,
          activities: clearActivityCheckBoxSelection,
          isLastVisited: false,
        };
      }
    });
    return {
      ...state,
      modules: updatedModule,
    };
  }
}
